// extracted by mini-css-extract-plugin
module.exports = {"Card":"cardItem_Card__YOaxC","CardName":"cardItem_CardName__2UIRF","CardComments":"cardItem_CardComments__2fM2-"};